<template>
  <div>
    <div v-if="recognizedText">
      <label for="recognized-text">Texto Reconhecido:</label>
      <b-form-input
        readonly
        id="recognized-text"
        :value="recognizedText"
        style="margin-bottom: 20px;"
      ></b-form-input>
    </div>
    <label>O valor está correto?</label>
    <div>
      <b-button variant="green" class="button" size="sm" @click="confirmText"
        >Sim</b-button
      >
      <b-button variant="warning" class="button" size="sm" @click="editText"
        >Não</b-button
      >
      <b-button class="button" size="sm" @click="close">Cancelar</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OcrPreviewModal",
  props: {
    recognizedText: [String, Array],
    checklistValue: Object,
    imageSrc: String
  },
  computed: {
    displayText() {
      if (
        Array.isArray(this.recognizedText) &&
        this.recognizedText.length > 0
      ) {
        return this.recognizedText.map(item => item.text).join(" ");
      }
      return this.recognizedText;
    }
  },
  methods: {
    confirmText() {
      if (
        this.checklistValue.ocrScanLog &&
        this.checklistValue.ocrScanLog.AttachmentPath
      ) {
        this.$emit("remove-ocr-attachment", this.checklistValue.fieldId);
      }

      this.checklistValue.value = this.recognizedText;
      this.checklistValue.ocrScanLog = {
        id: 0,
        checklistValueId: this.checklistValue.id,
        attachmentPath: this.imageSrc,
        editedValue: 0,
        scannedValue: this.recognizedText,
        isEdited: 0,
        ocrType: this.checklistValue.ocrType,
        fieldId: this.checklistValue.fieldId
      };
      this.$emit("confirm-text", this.checklistValue);
    },
    editText() {
      this.$emit("edit-text");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.button {
  margin-right: 10px;
}
</style>
